import { drawerStyles } from "../styles/shared/drawerStyles";
// src/components/ReusableRightDrawer.jsx
import React from "react";
import { Drawer, Box, IconButton } from "@mui/material";
import { Add } from "iconsax-react";

/**
 * ReusableRightDrawer
 * - Fixed header
 * - Scrollable content body
 * - Optional footer
 */
export default function ReusableRightDrawer({
  open,
  onClose,
  id,
  width = 546,
  headerLeft = null,
  headerRight = null,
  closeVariant = "text",
  closeColor = "#9C4FFF",
  paperSx = {},
  footer = null,
  children }) {
  const showDefaultClose = !headerRight;

  const closeBtnSx = drawerStyles.closeButton({ closeColor });

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      data-id={id}
      PaperProps={{
        sx: drawerStyles.paper({ width, paperSx }) }}
    >
      <Box
        sx={drawerStyles.root()}
      >
        {/* Header */}
        <Box
          sx={drawerStyles.header()}
        >
          <Box sx={drawerStyles.headerLeft()}>
            {headerLeft}
          </Box>

          <Box sx={drawerStyles.headerRight()}>
            {headerRight ? (
              headerRight
            ) : showDefaultClose ? (
              <IconButton onClick={onClose} size="small" sx={closeBtnSx}>
                {/* ✅ Iconsax has no "Close" export: rotate Add to make an "X" */}
                <Add
                  size="12"
                  color="#ffffff"
                  variant="Linear"
                  style={drawerStyles.closeIcon()}
                />
              </IconButton>
            ) : null}
          </Box>
        </Box>

        {/* Scrollable body */}
        <Box
          sx={drawerStyles.content()}
        >
          {children}
        </Box>

        {/* Footer */}
        {footer ? (
          <Box
            sx={drawerStyles.footer()}
          >
            {footer}
          </Box>
        ) : null}
      </Box>
    </Drawer>
  );
}